import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { logoutUser } from '../../actions/authActions';
import Banner from '../common/Banner';
import TextField from '../common/TextField';
import {
  editCompany,
  getCompanyByID,
  clearCurrentCompany,
  deleteCompanyByID,
} from '../../actions/companyActions';
import { getInfosByPage } from '../../actions/infoActions';
import SideNavbar from '../layout/SideNavbar';
import Navbar from '../layout/Navbar';
import SelectList from '../common/SelectList';
import { FormattedMessage, injectIntl } from 'react-intl';
import options from '../common/Options';
import Cleave from 'cleave.js/react';
import classnames from 'classnames';
import ReactQuill from 'react-quill';
import Spinner from '../common/Spinner';
import ReactTooltip from 'react-tooltip';
import isEmpty from '../../validation/is-empty';
import 'react-quill/dist/quill.snow.css';

class EditCompany extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      field: '',
      companyid: '',
      address: '',
      description: '',
      descriptionEn: '',
      phone: '',
      email: '',
      website: '',
      social: {
        youtube: '',
        twitter: '',
        facebook: '',
        instagram: '',
      },
      photo: null,
      isreviewed: false,
      uploadMessage: '',
      formSubmit: false,
      errors: {},
    };
    this.onEditorChange = this.onEditorChange.bind(this);
    this.onEditorChangeEn = this.onEditorChangeEn.bind(this);
  }

  componentDidMount() {
    document.title = this.props.intl.formatMessage({
      id: 'editcompany.title',
    });
    this.props.getCompanyByID(this.props.match.params.company_id);
    this.props.getInfosByPage('company');
    this.props.clearCurrentCompany();
  }

  componentDidUpdate(prevProps) {
    if (this.props.company !== prevProps.company) {
      const { ...company } = this.props.company.company_item;
      this.setState((prevState) => ({
        ...prevState,
        ...company,
      }));
    }
  }
  static getDerivedStateFromProps(props, state) {
    if (props.errors !== state.errors) {
      return { errors: props.errors, formSubmit: false };
    }
    return null;
  }

  onLogoutClick(e) {
    e.preventDefault();
    //this.props.clearCurrentProfile();
    this.props.logoutUser();
  }

  onDeleteClick(e) {
    e.preventDefault();
    let message = '';
    if (this.props.locale.lang === 'en') message = 'Are you sure?';
    else message = 'Oletko varma?';
    if (window.confirm(message)) {
      this.props.deleteCompanyByID(
        this.props.match.params.company_id,
        this.props.history
      );
    }
  }

  onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  onEditorChange(value) {
    this.setState({ description: value });
  }

  onEditorChangeEn(value) {
    this.setState({ descriptionEn: value });
  }

  onSocialChange = (e) => {
    this.setState({
      social: { ...this.state.social, [e.target.name]: e.target.value },
    });
  };

  onFileSelect = (event) => {
    this.setState({
      photo: event.target.files[0],
      uploadMessage: event.target.value.replace('C:\\fakepath\\', ''),
    });
  };

  onClick = (e) => {
    e.preventDefault();
    this.setState({ formSubmit: true }, () => {
      this.onSubmit();
    });
  };

  onSubmit() {
    let website, twitter, facebook, instagram, youtube;

    this.state.website === 'https://'
      ? (website = '')
      : (website = this.state.website);
    this.state.social.twitter === 'https://'
      ? (twitter = '')
      : (twitter = this.state.social.twitter);
    this.state.social.facebook === 'https://'
      ? (facebook = '')
      : (facebook = this.state.social.facebook);
    this.state.social.instagram === 'https://'
      ? (instagram = '')
      : (instagram = this.state.social.instagram);
    this.state.social.youtube === 'https://'
      ? (youtube = '')
      : (youtube = this.state.social.youtube);

    const companyData = new FormData();
    if (this.state.photo !== null)
      companyData.append('photo', this.state.photo);
    companyData.append('name', this.state.name);
    companyData.append('field', this.state.field);
    companyData.append('fieldEn', this.state.fieldEn);
    companyData.append('companyid', this.state.companyid);
    companyData.append('address', this.state.address);
    companyData.append('description', this.state.description);
    companyData.append('descriptionEn', this.state.descriptionEn);
    companyData.append('phone', this.state.phone);
    companyData.append('email', this.state.email);
    companyData.append('website', website);
    companyData.append('category', this.state.category);
    companyData.append('secondaryCategory', this.state.secondaryCategory);
    companyData.append('isreviewed', this.state.isreviewed);
    companyData.append('locale', this.props.locale.lang);

    // Social
    companyData.append('youtube', youtube);
    companyData.append('twitter', twitter);
    companyData.append('facebook', facebook);
    companyData.append('instagram', instagram);

    this.props.editCompany(
      companyData,
      this.props.match.params.company_id,
      this.props.history,
      this.props.auth.user.isAdmin
    );
  }
  render() {
    const { errors, social, uploadMessage } = this.state;
    const { infos, loading } = this.props.info;
    return (
      <div>
        <Navbar />
        <FormattedMessage id="editcompany.editcompany">
          {(editcompany) => <Banner pageName={editcompany} />}
        </FormattedMessage>
        <section className="user-page section-padding">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-5 col-xs-12">
                <SideNavbar />
              </div>
              <div className="col-lg-8 col-md-7 col-xs-12">
                <div className="my-address">
                  <h3 className="heading">
                    <FormattedMessage id="editcompany.editcompany" />
                  </h3>
                  <div className="section-inforamation">
                    {isEmpty(infos) || loading ? (
                      <Spinner />
                    ) : (
                        <form>
                          <div className="row">
                            <ReactTooltip place="right" multiline={true} />
                            <div className="col-sm-6">
                              <FormattedMessage id="createcompany.companyname">
                                {(companyname) => (
                                  <FormattedMessage id="createcompany.EnterYourCompanyName">
                                    {(EnterYourCompanyName) => (
                                      <TextField
                                        label={companyname}
                                        placeholder={EnterYourCompanyName}
                                        name="name"
                                        type="text"
                                        value={this.state.name}
                                        onChange={this.onChange}
                                        error={errors.name}
                                        required={true}
                                        info={this.props.info}
                                        locale={this.props.locale}
                                      />
                                    )}
                                  </FormattedMessage>
                                )}
                              </FormattedMessage>
                            </div>
                            <div className="col-sm-6">
                              <FormattedMessage id="createcompany.category">
                                {(category) => (
                                  <SelectList
                                    name="category"
                                    value={this.state.category}
                                    onChange={this.onChange}
                                    option={options}
                                    error={errors.category}
                                    label={category}
                                    required={true}
                                    info={this.props.info}
                                    locale={this.props.locale}
                                  />
                                )}
                              </FormattedMessage>
                            </div>
                            <div className="col-sm-6">
                              <FormattedMessage id="createcompany.secondaryCategory">
                                {(secondaryCategory) => (
                                  <SelectList
                                    name="secondaryCategory"
                                    value={this.state.secondaryCategory}
                                    onChange={this.onChange}
                                    option={options}
                                    error={errors.secondaryCategory}
                                    label={secondaryCategory}
                                    info={this.props.info}
                                    locale={this.props.locale}
                                  />
                                )}
                              </FormattedMessage>
                            </div>
                            <div className="col-sm-6">
                              <FormattedMessage id="createcompany.CompanyField">
                                {(CompanyField) => (
                                  <FormattedMessage id="createcompany.EnterYourCompanyField">
                                    {(EnterYourCompanyField) => (
                                      <TextField
                                        label={CompanyField}
                                        placeholder={EnterYourCompanyField}
                                        name="field"
                                        type="text"
                                        value={this.state.field}
                                        onChange={this.onChange}
                                        error={errors.field}
                                        required={true}
                                        info={this.props.info}
                                        locale={this.props.locale}
                                      />
                                    )}
                                  </FormattedMessage>
                                )}
                              </FormattedMessage>
                            </div>
                            <div className="col-sm-6">
                              <FormattedMessage id="createcompany.CompanyFieldEn">
                                {(CompanyField) => (
                                  <FormattedMessage id="createcompany.EnterYourCompanyFieldEn">
                                    {(EnterYourCompanyField) => (
                                      <TextField
                                        label={CompanyField}
                                        placeholder={EnterYourCompanyField}
                                        name="fieldEn"
                                        type="text"
                                        value={this.state.fieldEn}
                                        onChange={this.onChange}
                                        error={errors.fieldEn}
                                        info={this.props.info}
                                        locale={this.props.locale}
                                      />
                                    )}
                                  </FormattedMessage>
                                )}
                              </FormattedMessage>
                            </div>
                            <div className="col-sm-6">
                              <FormattedMessage id="createcompany.BusinessID">
                                {(BusinessID) => (
                                  <FormattedMessage id="createcompany.EnterYourBusinessID">
                                    {(EnterYourBusinessID) => (
                                      <div className="form-group">
                                        <label>
                                          {BusinessID}
                                          <span className="text-danger">&nbsp;*</span>
                                          {!isEmpty(
                                            this.props.info.infos.find(
                                              (item) =>
                                                'companyid' === item.name &&
                                                this.props.locale.lang ===
                                                item.lang
                                            )
                                          ) && (
                                              <img
                                                src="img/information.png"
                                                className="info"
                                                alt=""
                                                data-tip={
                                                  this.props.info.infos.find(
                                                    (item) =>
                                                      'companyid' === item.name &&
                                                      this.props.locale.lang ===
                                                      item.lang
                                                  ).text
                                                }
                                              />
                                            )}
                                        </label>
                                        <Cleave
                                          className={classnames('form-control', {
                                            'is-invalid': errors.companyid,
                                          })}
                                          options={{
                                            delimiter: '-',
                                            blocks: [7, 1],
                                            numericOnly: true,
                                          }}
                                          placeholder={EnterYourBusinessID}
                                          name="companyid"
                                          value={this.state.companyid}
                                          onChange={this.onChange}
                                        />
                                        {errors.companyid && (
                                          <div className="invalid-feedback">
                                            {errors.companyid}
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </FormattedMessage>
                                )}
                              </FormattedMessage>
                            </div>
                            <div className="col-sm-6">
                              <FormattedMessage id="createcompany.PhoneNumber">
                                {(PhoneNumber) => (
                                  <FormattedMessage id="createcompany.PhoneNumberExample">
                                    {(PhoneNumberExample) => (
                                      <div className="form-group">
                                        <label>
                                          {PhoneNumber}
                                          {!isEmpty(
                                            this.props.info.infos.find(
                                              (item) =>
                                                'phone' === item.name &&
                                                this.props.locale.lang ===
                                                item.lang
                                            )
                                          ) && (
                                              <img
                                                src="img/information.png"
                                                className="info"
                                                alt=""
                                                data-tip={
                                                  this.props.info.infos.find(
                                                    (item) =>
                                                      'phone' === item.name &&
                                                      this.props.locale.lang ===
                                                      item.lang
                                                  ).text
                                                }
                                              />
                                            )}
                                        </label>
                                        <Cleave
                                          className={classnames('form-control', {
                                            'is-invalid': errors.phone,
                                          })}
                                          options={{
                                            delimiter: ' ',
                                            blocks: [3, 3, 5],
                                            numericOnly: true,
                                          }}
                                          placeholder={PhoneNumberExample}
                                          name="phone"
                                          value={this.state.phone}
                                          onChange={this.onChange}
                                        />
                                        {errors.phone && (
                                          <div className="invalid-feedback">
                                            {errors.phone}
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </FormattedMessage>
                                )}
                              </FormattedMessage>
                            </div>
                            <div className="col-sm-6">
                              <FormattedMessage id="createcompany.EmailAddress">
                                {(EmailAddress) => (
                                  <FormattedMessage id="createcompany.EmailAddressExample">
                                    {(EmailAddressExample) => (
                                      <TextField
                                        label={EmailAddress}
                                        placeholder={EmailAddressExample}
                                        name="email"
                                        type="email"
                                        value={this.state.email}
                                        onChange={this.onChange}
                                        error={errors.email}
                                        info={this.props.info}
                                        locale={this.props.locale}
                                        required={true}
                                      />
                                    )}
                                  </FormattedMessage>
                                )}
                              </FormattedMessage>
                            </div>
                            <div className="col-sm-6">
                              <FormattedMessage id="createcompany.CompanyAddress">
                                {(CompanyAddress) => (
                                  <FormattedMessage id="createcompany.EnterYourCompanyAddress">
                                    {(EnterYourCompanyAddress) => (
                                      <TextField
                                        label={CompanyAddress}
                                        placeholder={EnterYourCompanyAddress}
                                        name="address"
                                        type="text"
                                        value={this.state.address}
                                        onChange={this.onChange}
                                        error={errors.address}
                                        required={true}
                                        info={this.props.info}
                                        locale={this.props.locale}
                                      />
                                    )}
                                  </FormattedMessage>
                                )}
                              </FormattedMessage>
                            </div>
                            <div className="col-sm-6">
                              <FormattedMessage id="createcompany.CompanyWebsite">
                                {(CompanyWebsite) => (
                                  <FormattedMessage id="createcompany.EnterYourCompanyWebsite">
                                    {(EnterYourCompanyWebsite) => (
                                      <div className="form-group">
                                        <label>
                                          {CompanyWebsite}
                                          {!isEmpty(
                                            this.props.info.infos.find(
                                              (item) =>
                                                'website' === item.name &&
                                                this.props.locale.lang ===
                                                item.lang
                                            )
                                          ) && (
                                              <img
                                                src="img/information.png"
                                                className="info"
                                                alt=""
                                                data-tip={
                                                  this.props.info.infos.find(
                                                    (item) =>
                                                      'website' === item.name &&
                                                      this.props.locale.lang ===
                                                      item.lang
                                                  ).text
                                                }
                                              />
                                            )}
                                        </label>
                                        <Cleave
                                          className={classnames('form-control', {
                                            'is-invalid': errors.website,
                                          })}
                                          options={{
                                            prefix: 'https://',
                                            lowercase: true,
                                          }}
                                          placeholder={EnterYourCompanyWebsite}
                                          name="website"
                                          value={this.state.website}
                                          onChange={this.onChange}
                                        />
                                        {errors.website && (
                                          <div className="invalid-feedback">
                                            {errors.website}
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </FormattedMessage>
                                )}
                              </FormattedMessage>
                            </div>
                            <div className="col-lg-12">
                              <FormattedMessage id="createcompany.CompanyDescription">
                                {(CompanyDescription) => (
                                  <FormattedMessage id="createcompany.Writeaboutyourcompany">
                                    {(Writeaboutyourcompany) => (
                                      <div>
                                        <label>
                                          {CompanyDescription}
                                          <span className="text-danger">
                                            &nbsp;*
                                        </span>
                                          {!isEmpty(
                                            this.props.info.infos.find(
                                              (item) =>
                                                'description' === item.name &&
                                                this.props.locale.lang ===
                                                item.lang
                                            )
                                          ) && (
                                              <img
                                                src="img/information.png"
                                                className="info"
                                                alt=""
                                                data-tip={
                                                  this.props.info.infos.find(
                                                    (item) =>
                                                      'description' === item.name &&
                                                      this.props.locale.lang ===
                                                      item.lang
                                                  ).text
                                                }
                                              />
                                            )}
                                        </label>
                                        <div
                                          className={classnames('editor', {
                                            'is-invalid': errors.description,
                                          })}
                                        >
                                          <ReactQuill
                                            value={this.state.description}
                                            onChange={this.onEditorChange}
                                            modules={EditCompany.modules}
                                            formats={EditCompany.formats}
                                            placeholder={Writeaboutyourcompany}
                                          />
                                          {errors.description && (
                                            <div className="invalid-feedback">
                                              {errors.description}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </FormattedMessage>
                                )}
                              </FormattedMessage>
                            </div>
                            <div className="col-lg-12">
                              <FormattedMessage id="createcompany.CompanyDescriptionEn">
                                {(CompanyDescriptionEn) => (
                                  <FormattedMessage id="createcompany.WriteaboutyourcompanyEn">
                                    {(WriteaboutyourcompanyEn) => (
                                      <div>
                                        <label>
                                          {CompanyDescriptionEn}
                                          {!isEmpty(
                                            this.props.info.infos.find(
                                              (item) =>
                                                'descriptionEn' === item.name &&
                                                this.props.locale.lang ===
                                                item.lang
                                            )
                                          ) && (
                                              <img
                                                src="img/information.png"
                                                className="info"
                                                alt=""
                                                data-tip={
                                                  this.props.info.infos.find(
                                                    (item) =>
                                                      'descriptionEn' ===
                                                      item.name &&
                                                      this.props.locale.lang ===
                                                      item.lang
                                                  ).text
                                                }
                                              />
                                            )}
                                        </label>
                                        <div
                                          className={classnames('editor', {
                                            'is-invalid': errors.descriptionEn,
                                          })}
                                        >
                                          <ReactQuill
                                            value={this.state.descriptionEn}
                                            onChange={this.onEditorChangeEn}
                                            modules={EditCompany.modules}
                                            formats={EditCompany.formats}
                                            placeholder={WriteaboutyourcompanyEn}
                                          />
                                          {errors.descriptionEn && (
                                            <div className="invalid-feedback">
                                              {errors.descriptionEn}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </FormattedMessage>
                                )}
                              </FormattedMessage>
                            </div>
                            <div className="col-lg-12 mb-4">
                              <label>
                                <FormattedMessage id="createproduct.photo" />
                                {!isEmpty(
                                  this.props.info.infos.find(
                                    (item) =>
                                      'photo' === item.name &&
                                      this.props.locale.lang === item.lang
                                  )
                                ) && (
                                    <img
                                      src="img/information.png"
                                      className="info"
                                      alt=""
                                      data-tip={
                                        this.props.info.infos.find(
                                          (item) =>
                                            'photo' === item.name &&
                                            this.props.locale.lang === item.lang
                                        ).text
                                      }
                                    />
                                  )}
                              </label>
                              <div className="custom-file">
                                <input
                                  type="file"
                                  className="custom-file-input"
                                  id="customFile"
                                  onChange={this.onFileSelect}
                                  ref={(ref) => (this.fileUpload = ref)}
                                />
                                <label
                                  className="custom-file-label"
                                  htmlFor="customFile"
                                >
                                  {uploadMessage ? (
                                    uploadMessage
                                  ) : (
                                      <FormattedMessage id="editprofile.Uploadyouravatar" />
                                    )}
                                </label>
                              </div>
                              {errors.avatar && (
                                <div className="invalid-feedback">
                                  {errors.avatar}
                                </div>
                              )}
                              <label>
                                <FormattedMessage id="createcompany.optimalsize" />
                              </label>
                            </div>
                            <div className="col-sm-6 page-login-form">
                              <div className="login-form">
                                <FormattedMessage id="createcompany.URLtoyourTwitter">
                                  {(URLtoyourTwitter) => (
                                    <div className="form-group">
                                      <div className="input-icon">
                                        <i className="lni-twitter" />
                                        <Cleave
                                          className={classnames('form-control', {
                                            'is-invalid': errors.twitter,
                                          })}
                                          options={{
                                            prefix: 'https://',
                                            lowercase: true,
                                          }}
                                          placeholder={URLtoyourTwitter}
                                          name="twitter"
                                          value={social.twitter}
                                          onChange={this.onSocialChange}
                                        />
                                        {errors.twitter && (
                                          <div className="invalid-feedback">
                                            {errors.twitter}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </FormattedMessage>
                              </div>
                            </div>
                            <div className="col-sm-6 page-login-form">
                              <div className="login-form">
                                <FormattedMessage id="createcompany.URLtoyourFacebook">
                                  {(URLtoyourFacebook) => (
                                    <div className="form-group">
                                      <div className="input-icon">
                                        <i className="lni-facebook" />
                                        <Cleave
                                          className={classnames('form-control', {
                                            'is-invalid': errors.facebook,
                                          })}
                                          options={{
                                            prefix: 'https://',
                                            lowercase: true,
                                          }}
                                          placeholder={URLtoyourFacebook}
                                          name="facebook"
                                          value={social.facebook}
                                          onChange={this.onSocialChange}
                                        />
                                        {errors.facebook && (
                                          <div className="invalid-feedback">
                                            {errors.facebook}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </FormattedMessage>
                              </div>
                            </div>
                            <div className="col-sm-6 page-login-form">
                              <div className="login-form">
                                <FormattedMessage id="createcompany.URLtoyourInstagram">
                                  {(URLtoyourInstagram) => (
                                    <div className="form-group">
                                      <div className="input-icon">
                                        <i className="lni-instagram" />
                                        <Cleave
                                          className={classnames('form-control', {
                                            'is-invalid': errors.instagram,
                                          })}
                                          options={{
                                            prefix: 'https://',
                                            lowercase: true,
                                          }}
                                          placeholder={URLtoyourInstagram}
                                          name="instagram"
                                          value={social.instagram}
                                          onChange={this.onSocialChange}
                                        />
                                        {errors.instagram && (
                                          <div className="invalid-feedback">
                                            {errors.instagram}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </FormattedMessage>
                              </div>
                            </div>
                            <div className="col-sm-6 page-login-form">
                              <div className="login-form">
                                <FormattedMessage id="createcompany.URLtoyourYoutube">
                                  {(URLtoyourYoutube) => (
                                    <div className="form-group">
                                      <div className="input-icon">
                                        <i class="lni-youtube" />
                                        <Cleave
                                          className={classnames('form-control', {
                                            'is-invalid': errors.youtube,
                                          })}
                                          options={{
                                            prefix: 'https://',
                                            lowercase: true,
                                          }}
                                          placeholder={URLtoyourYoutube}
                                          name="youtube"
                                          value={social.youtube}
                                          onChange={this.onSocialChange}
                                        />
                                        {errors.youtube && (
                                          <div className="invalid-feedback">
                                            {errors.youtube}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </FormattedMessage>
                              </div>
                            </div>
                            <div className="mx-auto">
                              <FormattedMessage id="editcompany.savecompany">
                                {(editcompany) => (
                                  <button
                                    type="submit"
                                    className="btn btn-common mt-2"
                                    onClick={this.onClick}
                                    disabled={this.state.formSubmit}
                                  >
                                    {this.state.formSubmit && (
                                      <span
                                        className="spinner-border spinner-border-sm mr-2"
                                        role="status"
                                        aria-hidden="true"
                                        disabled={this.state.formSubmit}
                                      ></span>
                                    )}
                                    {editcompany}
                                  </button>
                                )}
                              </FormattedMessage>
                              <button
                                onClick={this.onDeleteClick.bind(this)}
                                className="btn btn-border-danger mt-2 ml-2"
                              >
                                <FormattedMessage id="editproduct.deleteproduct" />
                              </button>
                              <NavLink exact to="/dashboard">
                                <div className="btn btn-border mt-2 ml-2">
                                  <FormattedMessage id="editcompany.cancelcompany" />
                                </div>
                              </NavLink>
                            </div>
                          </div>
                        </form>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

EditCompany.modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' }],
  ],
};

EditCompany.formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'blockquote',
  'list',
  'bullet',
];

EditCompany.propTypes = {
  auth: PropTypes.object.isRequired,
  locale: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  company: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  company: state.company,
  info: state.info,
  errors: state.errors,
  locale: state.locale,
});

export default connect(mapStateToProps, {
  logoutUser,
  editCompany,
  getCompanyByID,
  getInfosByPage,
  clearCurrentCompany,
  deleteCompanyByID,
})(withRouter(injectIntl(EditCompany)));
